<div class="filter-range">
  <ng-container *ngIf="isLoading; then loader; else dateInputs"></ng-container>
</div>
<ng-template #loader>
  <div class="filter-placeholder filter-placeholder-range">
    <div class="range-start-placeholder"></div>
    <span class="range-separator">&mdash;</span>
    <div class="range-end-placeholder"></div>
  </div>
</ng-template>
<ng-template #dateInputs>
  <div class="field-group">
    <mode-date-picker
      class="range-filter-input"
      data-test="range-filter-date-min"
      [minDate]="dataMinDate"
      [date]="filterStartDate"
      [placeholder]="startDisplayDate"
      (dateChange)="onFilterStartDateChange($event)"
    ></mode-date-picker>
    <span class="range-separator">&mdash;</span>
    <mode-date-picker
      class="range-filter-input"
      data-test="range-filter-date-max"
      [minDate]="dataMaxDate"
      [date]="filterEndDate"
      [placeholder]="endDisplayDate"
      (dateChange)="onFilterEndDateChange($event)"
    ></mode-date-picker>
  </div>
</ng-template>
